import OrderFlowDeliveryPage from '../pages/flow/OrderFlowDeliveryPage'
import OrderFlowKitchenPage from '../pages/flow/OrderFlowKitchenPage'
import OrderFlowOvenPage from '../pages/flow/OrderFlowOvenPage'
import OrderFlowPage from '../pages/flow/OrderFlowPage'
import OrderFlowSalonPage from '../pages/flow/OrderFlowSalonPage'
import OrderFlowWaiterPage from '../pages/flow/OrderFlowWaiterPage'
import OrderFlowAllPage from '../pages/flow/OrderFlowAllPage'


const routes = [
    {
        name: 'OrderFlowAllPage',
        path: '/flow/all',
        component: OrderFlowAllPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_VIEW_ALL_FLOW",
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowPage',
        path: '/flow/bar',
        component: OrderFlowPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_VIEW_BAR_FLOW",
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowKitchenPage',
        path: '/flow/kitchen',
        component: OrderFlowKitchenPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_SHOW_KITCHEN",
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowOvenPage',
        path: '/flow/oven',
        component: OrderFlowOvenPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_SHOW_OVEN",
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowDeliveryPage',
        path: '/flow/delivery',
        component: OrderFlowDeliveryPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_SHOW_DELIVERY",
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowSalonPage',
        path: '/flow/salon',
        component: OrderFlowSalonPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_SHOW_SALON",
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowWaiterPage',
        path: '/flow/waiter',
        component: OrderFlowWaiterPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_SHOW_WAITER",
            disableFooter: true
        }
    }

]

export default routes;
